import { portaleHelpers, getPortaleId } from "./utils/portaleUtils";

export const portaleConfig = portaleHelpers[getPortaleId()];

window.document.title = portaleConfig.portaleNome;

export const isGattiFuture = getPortaleId() === 1;
export const isForeSight = getPortaleId() === 2;
export const isSala = getPortaleId() === 3;
